import { action, observable } from "mobx";
import moment from "moment";

export interface QueryLog {
  user_id?: string;
  user_name?: string;
  state: string;
  context: string;
  query: string;
  cost: number;
  data_scanned_in_bytes?: number;
  execution_time: number;
  created_at: string;
}

export type InitialProps = {
  logs: QueryLog[];
};

let store: Store | undefined;

export function getStore() {
  if (!store) {
    throw new Error("Store not initialized");
  }
  return store;
}

export function createStore(props: InitialProps) {
  store = new Store(props);
}

export interface Filter {
  filter(log: QueryLog): boolean;
  toString(): string;
}

export class UserFilter implements Filter {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }

  filter(log: QueryLog): boolean {
    return log.user_id === this.id;
  }

  toString(): string {
    return `user:${this.name}`;
  }
}

export class DayFilter implements Filter {
  day: number;

  constructor(day: number) {
    this.day = day;
  }

  filter(log: QueryLog): boolean {
    return moment(log.created_at).get("date") === this.day;
  }

  toString(): string {
    return `day:${this.day}`;
  }
}

class Store {
  readonly logs: QueryLog[];
  @observable accessor currentLogs: QueryLog[] = [];
  @observable accessor filters: Filter[] = [];

  constructor(props: InitialProps) {
    this.logs = props.logs;
    this.updateCurrentLogs();
  }

  @action addFilter(filter: Filter) {
    if (this.filters.some((f) => f.toString() === filter.toString())) {
      return this;
    }
    this.filters.push(filter);
    this.updateCurrentLogs();
  }

  @action removeFilter(index: number) {
    this.filters.splice(index, 1);
    this.updateCurrentLogs();
  }

  @action updateCurrentLogs() {
    this.currentLogs = this.logs.filter((l) =>
      this.filters.every((f) => f.filter(l)),
    );
  }
}
